import React, { useState } from 'react';
import './messages.css'; // Create and include your CSS file

const messages = {
  chairman: { 
    title: "Message from the Chairman",
    content: `It is with great honor and immense pleasure that I extend a warm welcome to all esteemed guests, distinguished speakers, and participants of the 9th International Conference at Shalamar Medical & Dental College. This conference marks yet another milestone in our ongoing pursuit of academic excellence and medical innovation.

Since its inception, Shalamar Medical & Dental College has remained steadfast in its mission to cultivate an environment where academic rigor meets clinical proficiency. Our commitment to nurturing intellectual curiosity, fostering research, and refining professional competencies has positioned us as a leading institution in medical education. This gathering of scholars, researchers, and healthcare professionals reflects our collective aspiration to advance medical knowledge and enhance patient care through meaningful dialogue and collaboration.

The significance of such academic engagements cannot be overstated. They serve as vital platforms for exchanging pioneering ideas, embracing emerging medical technologies, and strengthening professional networks that transcend geographical boundaries. As we host this distinguished event, we reaffirm our dedication to providing a stimulating and enriching experience for all participants.

I extend my deepest gratitude to the delegates, faculty members, and organizers whose contributions and commitments have made this conference a reality. Your presence here today underscores a shared vision of progress, learning, and the relentless pursuit of excellence in medical education and practice.

I look forward to the valuable insights and thought-provoking discussions that will shape the discourse of this conference. May this event serve as an inspiration for future collaborations and groundbreaking contributions to the field of healthcare.

With my highest regards and best wishes for a successful conference.

Shahid Hussain  
Chairman, Board of Trustees  
Shalamar Medical & Dental College`,
    signature: [
      "Shahid Hussain", 
      "Chairman, Board of Trustees", 
      "Shalamar Medical & Dental College"
    ],
    picture: "https://sihs.org.pk/wp-content/uploads/2024/05/Untitled-design-16.png"
  },
  principal: {
    title: "Message from the Principal",
    content: `It is an immense pleasure and a moment of great pride to welcome you all to the 9th International Conference at Shalamar Medical & Dental College. This prestigious event stands as a testament to our unwavering commitment to academic excellence, innovation, and the continuous pursuit of knowledge.

Shalamar Medical & Dental College has always prioritized excellence as the cornerstone of its mission. Our vision extends beyond imparting medical education; we are dedicated to grooming our students—both undergraduate and postgraduate—to become competent, ethical, and compassionate healthcare professionals. Through rigorous training, dynamic research opportunities, and a commitment to professional development, we strive to shape the future of medicine in Pakistan and beyond.

This conference serves as a unique platform for intellectual exchange, fostering collaborations, and sharing cutting-edge advancements in medical sciences. It brings together distinguished scholars, researchers, and healthcare professionals who share our passion for excellence in medical education, patient care, and research.

I extend my heartfelt gratitude to the organizers, faculty members, and participants who have contributed to making this conference a success. Your dedication and enthusiasm inspire us to continue our journey toward academic and clinical excellence.

I hope this conference proves to be an enriching experience for all attendees, and I look forward to witnessing the fruitful discussions and innovations that will emerge from this gathering.

Prof. Zahid Bashir  
Principal,  
Shalamar Medical & Dental College`,
    signature: [
      "Prof. Zahid Bashir",
      "Principal,",
      "Shalamar Medical & Dental College"
    ],
     picture: "https://smdc.edu.pk/wp-content/uploads/2022/04/zb.jpg"
  },
  chair: {
    title: "Message from the Chair, Organizing Committee",
    content: `It is with great excitement and a deep sense of pride that I welcome you all to the 9th International Conference at Shalamar Medical & Dental College. This conference is more than just an academic gathering—it is a celebration of knowledge, collaboration, and the shared commitment to excellence in medical education and healthcare.

At Shalamar, we strongly believe that academic excellence is not just about acquiring knowledge but about creating opportunities for learning, growth, and innovation. This conference is designed to bring together some of the brightest minds in the medical field, allowing our students and faculty to engage with and learn from the giants of the medical world. These interactions, discussions, and exchanges of ideas will undoubtedly inspire and empower all attendees to push boundaries, challenge perspectives, and strive for greater heights in their professional journeys.

What makes Shalamar truly unique is our dedicated Continuing Professional Development (CPD) Department, which is committed to fostering the growth and advancement of our faculty. Through structured programs, training workshops, and academic initiatives, we continuously invest in the professional development of our educators, ensuring they remain at the forefront of medical education and practice. This commitment to lifelong learning not only enhances faculty expertise but also enriches the learning experience for our students.

A successful event like this is only possible because of the unwavering dedication and hard work of our faculty, students, and organizing team. I am grateful to each one of you for making this conference a reality. To all our distinguished speakers, guests, and participants, thank you for joining us and for sharing your expertise and experience. Your presence enriches our academic community and reinforces our mission to nurture a culture of lifelong learning and professional excellence.

I hope this conference proves to be a truly enriching experience for all, sparking new ideas, forging new collaborations, and igniting a renewed passion for medical education and research. Let’s make the most of this incredible learning opportunity!

Prof. Sarah Khalid  
Chair, Organizing Committee`,
    signature: [
      "Prof. Sarah Khalid",
      "Chair, Organizing Committee"
    ],
     picture: "https://smdc.edu.pk/wp-content/uploads/2022/11/Dr.-Sarah-Khalid-scaled.jpg"
  }
};

const MessageModal = ({ message, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{message.title}</h2>
        <div className="modal-body">
          {message.content.split('\n').map((line, idx) => (
            <p key={idx}>{line}</p>
          ))}
        </div>
        <button className="close-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

// Card component for each message
const MessageCard = ({ message, onView }) => {
  return (
    <div className="card">
      <div className="card-header">
        <h3>{message.title}</h3>
      </div>
      <div className="card-body">
        <img src={message.picture} alt="" className="card-img" />
        <div className="card-signature">
          {message.signature.map((line, index) => (
            <h4 key={index}>{line}</h4>
          ))}
        </div>
        <button className="view-btn" onClick={onView}>View the Message</button>
      </div>
    </div>
  );
};

// Main component that renders all cards and handles modal state
const MessagesComponent = () => {
  const [selectedMessage, setSelectedMessage] = useState(null);

  const openModal = (key) => {
    setSelectedMessage(messages[key]);
  };

  const closeModal = () => {
    setSelectedMessage(null);
  };

  return (
    <div className="messages-container">
      <MessageCard message={messages.chairman} onView={() => openModal('chairman')} />
      <MessageCard message={messages.principal} onView={() => openModal('principal')} />
      <MessageCard message={messages.chair} onView={() => openModal('chair')} />
      {selectedMessage && <MessageModal message={selectedMessage} onClose={closeModal} />}
    </div>
  );
};

export default MessagesComponent;
